<ng-container *ngIf="!skipIndexes.includes(index)">
  <ng-container *ngIf="isFullDate; else textComponent">
    <mat-form-field appearance="fill">
      <mat-label>{{ '+GENERAL.DATEPICKER.DAY_PICKER' | translate }}</mat-label>
      <input
        data-at-remote-diagnostics-edit-value="date"
        matInput
        readonly
        fieldTextContentTooltip
        [matDatepicker]="datepicker"
        [formControl]="datepickerDate"
        (dateChange)="onDateChange($event)"
      />
      <mat-datepicker-toggle
        data-at-date-picker-button
        matSuffix
        [for]="datepicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #datepicker panelClass="day-datepicker"> </mat-datepicker>
    </mat-form-field>
  </ng-container>
  <ng-template #textComponent>
    <ng-container *ngFor="let index of skippedIndexes">
      <app-vdd-text-edit
        data-at-structure-value
        [matchedValue]="matchedValues[index]"
        [isDescription]="false"
      ></app-vdd-text-edit>
    </ng-container>
  </ng-template>
</ng-container>
